var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.loaded
    ? _c("lift-and-sift", {
        key: _setup.requestKey,
        attrs: {
          "api-root": _setup.apiRoot,
          jwt: _setup.token,
          "verification-token": _setup.verificationToken,
          "enable-record-type": "",
          "enable-limits": "",
          "enable-pivots": "",
          "enable-migrations": "",
          "enable-lookups": "",
          "enable-header-edit": "",
          "enable-carves": "",
        },
        domProps: {
          request: _setup.request,
          columnMinWidth: _vm.columnMinWidth,
          rowClassRules: _vm.rowClassRules,
          beforeRequestExecution: _setup.handleBeforeRequestExecution,
          beforeExport: _setup.handleBeforeExport,
          enableView: _vm.views,
          enableFilters: _vm.filters,
          enableGrouping: _vm.groups,
          enableStrats: _vm.strats,
          enableValidations: _vm.validations,
          enableFloatingFilters: _vm.columnFilters,
          enableExportToExcel: _vm.exportToExcel,
          enableCutCopyPaste: _vm.cutCopyPaste,
          enableExpand: _vm.expand,
          enableSummary: _vm.summaryMode,
          enableDataAlternate: _vm.dataAlternates,
          enableCheckboxRowSelection: _vm.useCheckboxRowSelection,
          enableSavingReport: _vm.enableSavingReport,
          enableSetCreation: _vm.sets || _vm.useCheckboxRowSelection,
          enableLoanStatus: _vm.partitions,
          enableSubdomainFilters: _vm.subdomainBox,
          enableTime: _vm.enableAsOfDateFilter,
          enableHighlighting: _vm.highlighting,
          enableRefresh: true,
          enableClearFilters: true,
          enableActions: true,
          showValidationDrawer: _vm.showValidationDrawer,
          openWithDrawer: _setup.openWithDrawer,
          showNewExpandIcon: _vm.showNewExpandIcon,
          showDevMessages: _vm.showDevMessages,
        },
        on: {
          requestchange: _setup.onRequestChange,
          selectionchanged: _setup.onSelectionChangedEvent,
          primarykeysselectionchanged:
            _setup.onPrimaryKeysSelectionChangedEvent,
          rowdoubleclicked: _setup.onRowDoubleClickedEvent,
          datafetching: _setup.onDataFetchingEvent,
          gridready: _setup.onGridReadyEvent,
          getcontextmenuitems: _setup.onGetContextMenuItems,
          expandchange: _setup.onExpandChangeEvent,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }